export default "__VITE_ASSET__zC79NtPS__"